<template>
  <div class="online-status-indicator">
    <a-badge
      :status="badgeStatus"
      class="status-badge"
    />
    <span class="status-text" :style="{ color: statusColor }">
      {{ statusText }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'OnlineStatusIndicator',
  data() {
    return {
      isOnline: true,
      statusText: 'online',
      badgeStatus: 'success',
      statusColor: '#52c41a'
    }
  },
  mounted() {
    this.setupOnlineStatusListeners()
  },
  methods: {
    setupOnlineStatusListeners() {
      Echo.private('hyperion-monitoring-transaction-banking-netman')
        .listen('Services.Banking.Netman', (e) => this.accepted(e))
    },
    accepted(event) {
      if (event.netman.responseCode === '0000') {
        this.isOnline = true
        this.statusText = 'online'
        this.badgeStatus = 'success'
        this.statusColor = '#52c41a'
      } else {
        this.isOnline = false
        this.statusText = 'offline'
        this.badgeStatus = 'error'
        this.statusColor = '#ff4d4f'
      }
    }
  }
}
</script>

<style scoped>
@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0.3; }
}

@keyframes pulse {
  0% { opacity: 1; transform: scale(1.2); }
  50% { opacity: 0.8; transform: scale(1.3); }
  100% { opacity: 1; transform: scale(1.2); }
}

@keyframes textBlink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0.4; }
}

.online-status-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.06);

  .status-badge {
    .ant-badge-status-dot {
      animation: pulse 3s infinite;
    }
  }

  .status-text {
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    cursor: default;
    user-select: none;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .online-status-indicator {
    .status-text {
      display: none;
    }
  }
}

@media (max-width: 576px) {
  .online-status-indicator {
    padding: 2px 4px;

    .status-badge {
      .ant-badge-status-dot {
        transform: scale(0.8);
      }
    }
  }
}
</style>
